export default __webpack_public_path__ + "ef594b1e3c44a72cbed606db60398f83.jpg";